import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleMenu = () => setIsOpen(prev => !prev);

  const toggleDropdown = (menu) => {
    setOpenDropdown(prev => (prev === menu ? null : menu));
  };

  const closeAll = () => {
    setIsOpen(false);
    setOpenDropdown(null);
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">


      <div className="navbar-header">
        <button
          type="button"
          className="navbar-toggle collapsed"
          onClick={toggleMenu}
        >
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
        </button>

        <NavLink className="navbar-brand" to="/" onClick={closeAll}>
          <img className="logo" src="/img/version1/logo.png" alt="logo" />
        </NavLink>
      </div>


      <div className={`collapse navbar-collapse ${isOpen ? "in" : ""}`}>
        <ul className="nav navbar-nav navbar-right">

          <li>
            <NavLink
              to="/qui_suis_je"
              onClick={() => setIsOpen(false)}
              className={({ isActive }) => `menu-link ${isActive ? "active" : ""}`}
              style={{ color: "#E01174", paddingBottom: "4px" }}
            >
              
              Qui suis-je
            </NavLink>
          </li>


          <li className="dropdown">
            <div
              className="menu-trigger fleuristerie"
              onClick={() => toggleDropdown("fleuristerie")}
              style={{
                color: "#E01174",
                cursor: "pointer",
                paddingBottom: "4px"
              }}
            >
              
              Fleuristerie ▾
            </div>

            <ul className={`dropdown-menu ${openDropdown === "fleuristerie" ? "show events" : ""}`}>
              <li>
                <NavLink to="/fleuristerie_artisanale/bouquets" className="menu-link" onClick={closeAll}>
                  Fleuristerie artisanale
                </NavLink>
              </li>
              <li>
                <NavLink to="/fleuristerie_artisanale/deuil" className="menu-link" onClick={closeAll}>
                  Deuil
                </NavLink>
              </li>
            </ul>
          </li>

          <li>
            <NavLink
              to="/plantes"
              onClick={() => setIsOpen(false)}
              className={({ isActive }) => `menu-link ${isActive ? "active" : ""}`}
              style={{ color: "#E01174", paddingBottom: "4px" }}
            >
              Plantes
            </NavLink>
          </li>


      <li className="dropdown">
            <div
              className="menu-trigger atelier"
              onClick={() => toggleDropdown("atelier")}
              style={{
                color: "#E01174",
                cursor: "pointer",
                paddingBottom: "4px"
              }}
            >
              Ateliers ▾
            </div>

            <ul className={`dropdown-menu ${openDropdown === "atelier" ? "show events" : ""}`}>
              <li>
                <NavLink to="/ateliers" className="menu-link" onClick={closeAll}>
                  Les ateliers
                </NavLink>
              </li>
              <li>
                <NavLink to="/ateliers_crèche" className="menu-link" onClick={closeAll}>
                  Ateliers pour crèche
                </NavLink>
              </li>
        
    <li>
                <NavLink to="/ateliers_senior" className="menu-link" onClick={closeAll}>
                 Ateliers pour sénior
                </NavLink>
              </li>
          </ul>
</li>


          <li className="dropdown">
            <div
              className="menu-trigger events"
              onClick={() => toggleDropdown("evenements")}
              style={{
                color: "#E01174",
                cursor: "pointer",
                paddingBottom: "4px"
              }}
            >
              Événements ▾
            </div>

            <ul className={`dropdown-menu ${openDropdown === "evenements" ? "show events" : ""}`}>
              <li>
              <NavLink
  to="/événements/mariage"
  className={({ isActive }) =>
    `menu-link ${isActive ? "active events" : "events"}`
  }
  onClick={closeAll}
>
  Mariage & Fiançailles
</NavLink>
              </li>
              <li>
               <NavLink
  to="/événements/autre"
  className={({ isActive }) =>
    `menu-link ${isActive ? "active events" : "events"}`
  }
  onClick={closeAll}
>
  Autres événements
</NavLink>
              </li>
            </ul>
          </li>



<li>
  <NavLink
    to="/paysagiste"
    className="menu-link paysagiste"
    onClick={closeAll}
    style={{paddingBottom: "4px" }}
  >
    Paysagiste
  </NavLink>
</li>

          <li>
            <NavLink
              to="/contact"
              onClick={() => setIsOpen(false)}
              className={({ isActive }) => `menu-link ${isActive ? "active" : ""}`}
              style={{ color: "#E01174", paddingBottom: "4px" }}
            >
              Contact
            </NavLink>
          </li>

        </ul>
      </div>
    </nav>
  );
};

export default Header;